import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { installPrerenderFetch } from './prerenderFetch';

// During react-snap prerendering only, serve API calls from a static data file
// instead of the live backend (avoids rate limits). No-op for real users.
installPrerenderFetch();

const rootEl = document.getElementById('root');
const tree = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// react-snap leaves prerendered markup in #root — hydrate it instead of
// throwing it away, so the static HTML Google sees matches what React renders.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
